import {
  ADD_SUB_STEP,
  ADD_USER_SELECTED,
  ALERT_DIALOG,
  ALERT_GO_TO_BEGINNING,
  ALERT_GO_TO_NEXT,
  ALL_INFO_USER,
  ALL_INFO_WAITING_ROOM,
  CGU,
  CLOSE_MAIN_DIALOG,
  CODE_SMS,
  DATE_SURVEY,
  DELETE_SUB_STEP,
  DETAIL_PATIENT,
  EMPTY_BREADCRUMBS,
  FAILED_APP,
  FAQ,
  FILES,
  FILES_DOWNLOAD,
  HISTORY,
  IS_FIRST_CONNEXION_WIDGET_PATIENT,
  IS_PATIENT_AREA,
  IS_VALID_SOCIAL_SECURITY,
  LINKED_ACCOUNTS,
  LIST_PATIENT,
  LOCALE_ADD_CATALOG,
  LOCALE_SET_LANGUAGE,
  MY_APPOINTMENTS,
  NEXT_STEP,
  ORIGIN_QR_CODE,
  PAYMENT,
  REMOVE_USER_SELECTED,
  REPLACE_SUB_STEP,
  RESET_RETURNED_VALUE,
  RESET_USER_DATA,
  SECRET_UPDATE,
  SET_ACTIVE_STEP,
  SET_BREADCRUMBS,
  SET_CONFIG,
  SET_DISABLE_BTN,
  SET_ENABLE_BTN,
  SET_FETCHER_APPOINTMENT,
  SET_FETCHER_URLS,
  SET_FIELD_DATA,
  SET_ITEM_BREADCRUMBS,
  SET_MESSAGE,
  SET_MESSAGE_WITH_CODE,
  SET_PRACTITIONERS,
  SET_RETURNED_VALUE,
  SET_STEP_BY_PASS,
  SET_STEPS,
  SHOW_BTN_NEXT,
  SHOW_CODE_PRIORITAIRE,
  SHOW_DIALOG_SMS,
  SHOW_FAQ,
  START_LOADING,
  STEP_REMOVE_CHILDREN,
  STOP_LOADING,
  TO_VALIDATE_TOKEN,
  USER_AREA,
  USER_DATA,
  USER_KEY,
  INFO_FOR_STATUS_FORM_FIELD,
  CONTINUE_HANDLE_FOOTER,
  SHOW_FOOTER_CONTINUE,
  DETAIL_PAYMENT,
  SET_APP_URL,
  MY_PARAMS,
  RESET_MESSAGE_WITH_CODE,
  RESET_USERS_SELECTED
} from "./action-types";

export const setConfig = config => ({
  type: SET_CONFIG,
  config
});

export const startLoading = () => ({
  type: START_LOADING
});

export const stopLoading = () => ({
  type: STOP_LOADING
});

export const failedApp = () => ({
  type: FAILED_APP
});

export const setSteps = steps => ({
  type: SET_STEPS,
  steps
});

export const setActiveStep = activeStep => ({
  type: SET_ACTIVE_STEP,
  activeStep
});
export const nextStep = steps => ({
  type: NEXT_STEP,
  steps
});

export const setEnableBtn = () => ({
  type: SET_ENABLE_BTN
});

export const setDisableBtn = () => ({
  type: SET_DISABLE_BTN
});

export const setReturnedValue = returnedValue => ({
  type: SET_RETURNED_VALUE,
  returnedValue
});
export const resetReturnedValue = () => ({
  type: RESET_RETURNED_VALUE
});

export const addSubStep = (stepIndex, subStep, subStepIndex = true) => ({
  type: ADD_SUB_STEP,
  stepIndex,
  subStep,
  subStepIndex
});
export const replaceSubStep = (stepIndex, subStep, subStepIndex) => ({
  type: REPLACE_SUB_STEP,
  stepIndex,
  subStep,
  subStepIndex
});
export const deleteSubStep = (stepIndex, subStepIndex) => ({
  type: DELETE_SUB_STEP,
  stepIndex,
  subStepIndex
});

export const removeStepChildren = activeStep => {
  return {
    type: STEP_REMOVE_CHILDREN,
    activeStep
  };
};

export const setStepByPass = (activeStep, byPassed) => ({
  type: SET_STEP_BY_PASS,
  activeStep,
  byPassed
});

export const addFieldData = (key, value) => ({
  type: SET_FIELD_DATA,
  payload: { [key]: value }
});

export const setMessage = message => ({
  type: SET_MESSAGE,
  message
});

export const setMessageWithCode = message => ({
  type: SET_MESSAGE_WITH_CODE,
  message
});

export const resetMessageWithCode = () => ({
  type: RESET_MESSAGE_WITH_CODE,
  undefined
});

export const setFetcherUrls = urls => ({
  type: SET_FETCHER_URLS,
  urls
});

export const setFetcherAppointment = appointmentMethod => ({
  type: SET_FETCHER_APPOINTMENT,
  appointmentMethod
});

export const setItemBreadcrumbs = itemBreadcrumbs => ({
  type: SET_ITEM_BREADCRUMBS,
  itemBreadcrumbs
});
export const setBreadcrumbs = breadcrumbs => ({
  type: SET_BREADCRUMBS,
  breadcrumbs
});
export const emptyBreadcrumbs = () => ({
  type: EMPTY_BREADCRUMBS
});

export const alertDialog = contentDialog => ({
  type: ALERT_DIALOG,
  contentDialog
});

export const setShowCodePrioritaire = isShow => ({
  type: SHOW_CODE_PRIORITAIRE,
  isShow
});

export const alertDialogGoToBeginning = goToBeginning => ({
  type: ALERT_GO_TO_BEGINNING,
  goToBeginning
});

export const alertDialogGoToNext = goToNext => ({
  type: ALERT_GO_TO_NEXT,
  goToNext
});

export const showFaq = isShow => ({
  type: SHOW_FAQ,
  isShow
});

export const showBtnNext = isShow => ({
  type: SHOW_BTN_NEXT,
  isShow
});

export const addUserSelected = idUser => ({
  type: ADD_USER_SELECTED,
  idUser
});

export const removeUserSelected = idUser => ({
  type: REMOVE_USER_SELECTED,
  idUser
});

export const resetUsersSelected = () => ({
  type: RESET_USERS_SELECTED
});

export const setUserKey = userKey => ({
  type: USER_KEY,
  userKey
});

export const userArea = isUserArea => ({
  type: USER_AREA,
  isUserArea
});

export const showDialogSms = isShow => ({
  type: SHOW_DIALOG_SMS,
  isShow
});

export const isFirstConnectionPatientArea = () => ({
  type: IS_FIRST_CONNEXION_WIDGET_PATIENT
});

export const toValidateToken = validateToken => ({
  type: TO_VALIDATE_TOKEN,
  validateToken
});

export const faq = contentFaq => ({
  type: FAQ,
  contentFaq
});

export const cgu = contentCgu => ({
  type: CGU,
  contentCgu
});

export const closeMainDialog = () => ({
  type: CLOSE_MAIN_DIALOG
});

export const setPractitioners = practitioners => ({
  type: SET_PRACTITIONERS,
  practitioners
});

export const codeSms = code => ({
  type: CODE_SMS,
  code
});

export const setUserData = userData => ({
  type: USER_DATA,
  userData
});
export const resetUserData = () => ({
  type: RESET_USER_DATA
});

export const localeAddCatalog = (locale, catalog) => ({
  type: LOCALE_ADD_CATALOG,
  locale,
  catalog
});
export const localeSetLanguage = language => ({
  type: LOCALE_SET_LANGUAGE,
  language
});
export const isPatientArea = active => ({
  type: IS_PATIENT_AREA,
  active
});
export const originQrCode = originQrCode => ({
  type: ORIGIN_QR_CODE,
  originQrCode
});
export const listPatients = patients => ({
  type: LIST_PATIENT,
  patients
});
export const myAppointments = myAppointments => ({
  type: MY_APPOINTMENTS,
  myAppointments
});
export const linkedAccounts = linkedAccounts => ({
  type: LINKED_ACCOUNTS,
  linkedAccounts
});
export const myHistory = history => ({
  type: HISTORY,
  history
});
export const myParams = params => ({
  type: MY_PARAMS,
  params
});
export const myFiles = files => ({
  type: FILES,
  files
});
export const filesDownload = files => ({
  type: FILES_DOWNLOAD,
  files
});
export const allInfoUser = infosUser => ({
  type: ALL_INFO_USER,
  infosUser
});
export const infoWaitingRoom = infosWaitingRoom => ({
  type: ALL_INFO_WAITING_ROOM,
  infosWaitingRoom
});

export const secretUpdate = secret => ({
  type: SECRET_UPDATE,
  secret
});

export const detailPatient = data => ({
  type: DETAIL_PATIENT,
  data
});

export const setPayment = data => ({
  type: PAYMENT,
  data
});

export const setPaymentDetails = data => ({
  type: DETAIL_PAYMENT,
  data
});

export const setSocialSecurity = data => ({
  type: IS_VALID_SOCIAL_SECURITY,
  data
});

export const setDateSurvey = data => ({
  type: DATE_SURVEY,
  data
});

export const infoForStatusFormField = infoForStatusFormField => ({
  type: INFO_FOR_STATUS_FORM_FIELD,
  infoForStatusFormField
});

export const handleContinueFooter = handler => ({
  type: CONTINUE_HANDLE_FOOTER,
  handler
});

export const showFooterContinue = continueBtn => ({
  type: SHOW_FOOTER_CONTINUE,
  continueBtn
});

export const setAppointmentUrl = appUrl => ({
  type: SET_APP_URL,
  appUrl
});
